export const Modal = ({ title, children, onClose }) => (
  <div className="modal-backdrop" onClick={onClose}>
    <div className="modal" onClick={(e) => e.stopPropagation()} data-testid="modal">
      <h3>{title}</h3>
      {children}
    </div>
  </div>
);

export const ConfirmModal = ({ title, body, onConfirm, onClose, danger }) => (
  <Modal title={title} onClose={onClose}>
    <p>{body}</p>
    <div className="actions">
      <button className="btn" onClick={onClose} data-testid="modal-cancel-btn">Annuler</button>
      <button
        className={`btn btn-p ${danger ? "" : ""}`}
        style={danger ? { background: "var(--bad)", borderColor: "var(--bad)" } : {}}
        onClick={onConfirm}
        data-testid="modal-confirm-btn"
      >
        Confirmer
      </button>
    </div>
  </Modal>
);
